import { isDefined } from '@sgme/fp';
import { type TypedError, useTypedErrorMessage } from 'utils/errors/errors';

export function ErrorAlert(props: TypedError) {
  const txt = useTypedErrorMessage(props);

  return isDefined(txt) ? (
    <div>
      <div className="mb-1 alert alert-discreet-danger flex-grow-1 overflow-y-auto" style={{ maxHeight: 100 }}>
        {txt}
      </div>
    </div>
  ) : undefined;
}
